(() => {
  const panel = document.createElement('div');
  panel.id = 'desktop-navigation-panel';
  panel.className = 'desktop-side-menu';
  panel.setAttribute('role', 'region');
  panel.setAttribute('aria-label', 'Menú principal');
  panel.setAttribute('aria-hidden', 'true');
  panel.inert = true;
  panel.innerHTML = '<div class="desktop-side-menu-content"><button type="button" class="close-side-menu" aria-label="Cerrar menú">✕</button><div data-menu-content></div></div>';
  document.body.appendChild(panel);
  const closeButton = panel.querySelector('.close-side-menu');
  const content = panel.querySelector('[data-menu-content]');
  const trigger = () => document.getElementById('desktop-hamburger');
  const isOpen = () => panel.classList.contains('active');
  function close(restoreFocus = false) {
    panel.classList.remove('active');
    panel.setAttribute('aria-hidden', 'true');
    panel.inert = true;
    trigger()?.setAttribute('aria-expanded', 'false');
    if (restoreFocus) trigger()?.focus();
  }
  function sync() {
    const source = document.querySelector('template[data-desktop-menu-source]');
    content.replaceChildren();
    if (source) content.appendChild(source.content.cloneNode(true));
  }
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    if (event.target.closest('#desktop-hamburger')) {
      if (window.innerWidth < 990) return;
      if (isOpen()) { close(true); return; }
      sync();
      panel.inert = false;
      panel.setAttribute('aria-hidden', 'false');
      panel.classList.add('active');
      trigger()?.setAttribute('aria-expanded', 'true');
      closeButton.focus();
    } else if (event.target.closest('.close-side-menu') || event.target.closest('#desktop-navigation-panel a')) {
      close(true);
    } else if (isOpen() && !panel.contains(event.target)) {
      close();
    }
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && isOpen()) { event.preventDefault(); close(true); }
  });
  document.addEventListener('focusin', (event) => {
    if (isOpen() && !panel.contains(event.target) && event.target !== trigger()) close();
  });
  window.addEventListener('resize', () => { if (window.innerWidth < 990) close(); });
  document.addEventListener('shopify:section:load', () => { close(); sync(); });
  document.addEventListener('shopify:section:unload', () => close());
  sync();
})();
